import admins from './admins/admins'
import main from './main/main'
export default {
  admins,
  main
}
